import {ActionContext, ActionTree} from 'vuex';
import {RootState} from '@/store';
import {CategoryState} from '@/store/modules/Category/state';
import {_axios} from '@/plugins/axios';
import {CategoryAPI, CategoryCreation, CategoryUpdate} from '#/Category';
import {AxiosError, AxiosResponse} from 'axios';

export const actions: ActionTree<CategoryState, RootState> = {
    createCategory: (
        {commit, dispatch}: ActionContext<CategoryState, RootState>,
        newCategory: CategoryCreation,
    ): Promise<void> => {
        return new Promise(resolve => {
            _axios.post(`categories/`, newCategory)
                  .then((response: AxiosResponse<CategoryAPI>) => {
                      commit('ADD_CATEGORY', response.data);
                      resolve();
                  })
                  .catch(error => {
                      dispatch('displayError', error.response, {root: true})
                          .then(() => {
                              resolve();
                          });
                  });
        });
    },

    deleteCategory: (
        {commit, dispatch}: ActionContext<CategoryState, RootState>,
        id: number,
    ): Promise<void> => {
        return new Promise(resolve => {
            _axios.delete(`categories/${id}/`)
                  .then(() => {
                      commit('DELETE_CATEGORY', id);
                      resolve();
                  })
                  .catch(error => {
                      dispatch('displayError', error.response, {root: true})
                          .then(() => {
                              resolve();
                          });
                  });
        });
    },

    loadCategories: ({state, commit, dispatch}: ActionContext<CategoryState, RootState>): Promise<void> => {
        return new Promise((resolve, reject) => {
            if (state.hasEmptyCategories) {
                _axios.get(`categories/`)
                      .then((response: AxiosResponse<CategoryAPI[]>) => {
                          commit('GET_CATEGORY', response.data);
                          resolve();
                      })
                      .catch((error: AxiosError) => {
                          dispatch('displayError', error.response, {root: true})
                              .then(() => {
                                  reject(error);
                              });
                      });
            } else {
                resolve();
            }
        });
    },

    updateCategory: (
        {commit, dispatch}: ActionContext<CategoryState, RootState>,
        {id, name}: CategoryUpdate,
    ): Promise<void> => {
        return new Promise(resolve => {
            _axios.patch(`categories/${id}/`, {name})
                  .then((response: AxiosResponse<CategoryAPI>) => {
                      commit('UPDATE_CATEGORY', response.data);
                      resolve();
                  })
                  .catch(error => {
                      dispatch('displayError', error.response, {root: true})
                          .then(() => {
                              resolve();
                          });
                  });
        });
    },
};
